export default "/assets/images/filter-recommandation-BS.jpg?6920f5b64fb62a26067d2a2d6ff30d87";